import * as React from "react";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { DistributionDividendPreference } from "../../../../../../Wrap/Constants/Enums/Domain/DistributionDividendPreference";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { MoneyOrPercentageType } from "../../../../../../Wrap/Constants/Enums/MoneyOrPercentageType";
import { GiaContributionModel } from "../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel";
import { IsaContributionModel } from "../../../../../../Wrap/Models/Models/Processes/OneOffPayment/Isa/IsaContributionModel";
import { WhatIfToolDetailModel } from "../../../../../../Wrap/Models/Models/Processes/WhatIfTool/WhatIfToolDetailModel";
import { CheckboxGroup } from "../../../../../Shared/CheckboxGroup/CheckboxGroup";
import { IProcessComponentProps, ProcessComponent } from "../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { ClientAccountStore } from "../../../../Stroes/Variable";
import { SubAccountTypeHelper } from "../../Common/Helpers/SubAccountTypeHelper";
import { SectionHeader } from "../../Common/SharedComponents";
import { whatIfModelArray, whatifProcess } from "../Resource/Contents";

interface IChangesToTheModelProps extends IProcessComponentProps {
    data: GiaContributionModel | IsaContributionModel;
    type: SubAccountType;
    extraInfo: WhatIfToolDetailModel;
}

interface IChangesToTheModelState {}

export class ChangesToTheModel extends ProcessComponent<IChangesToTheModelProps, IChangesToTheModelState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    isValid() {
        if (this.props.data?.Contribution?.ChangesToBeModeled.split(",").filter((ele) => ele != "").length == 0) {
            this.props.showErrorMsgPopUp(["Please at least select one model"]);
            return false;
        }
        return super.isValid();
    }

    private clearData = (model: whatifProcess) => {
        const { data, onChange, type } = this.props;
        const transferName = SubAccountTypeHelper.isPP(type) ? "GiaTransfers" : "IsaTransfers";
        const originSelected = (data?.Contribution?.ChangesToBeModeled || "").split(",");
        switch (model) {
            case whatifProcess.editPaymentIn:
                onChange({
                    Contribution: {
                        ...data?.Contribution,
                        ClientSinglePayment: null,
                        ThirdPartySinglePayment: null,
                        ClientRegularPyament: null,
                        ThirdPartyRegularPayment: null,
                        InstrumentSelections: {
                            Type: MoneyOrPercentageType.Percentage,
                            Instruments: [],
                            DistributionDividendPreference: DistributionDividendPreference.NotSpecified,
                        },
                        [transferName]: [],
                        ChangesToBeModeled: originSelected
                            .filter((ele) => {
                                ![
                                    whatifProcess.editInvestmentSeletion,
                                    whatifProcess.editAdviserCharges,
                                    whatifProcess.editPaymentIn,
                                ].includes(ele as whatifProcess);
                            })
                            .toString(),
                    },
                });
                break;
            case whatifProcess.editAdviserCharges:
                onChange({
                    Contribution: {
                        ...data?.Contribution,
                        InitialAdviserCharge: null,
                        OngoingAdviceCharge: null,
                        ChangesToBeModeled: originSelected.filter((ele) => ele != model).toString(),
                    },
                });
                break;
            case whatifProcess.AddAdditionalAdviserCharge:
                onChange({
                    Contribution: {
                        ...data?.Contribution,
                        AdHocAdviserCharge: { Amount: null, Currency: CurrencyCode.GBP },
                        ChangesToBeModeled: originSelected.filter((ele) => ele != model).toString(),
                    },
                });
                break;
            case whatifProcess.AddEditRegularWithdrawals:
                onChange({
                    Contribution: {
                        ...data?.Contribution,
                        RegularWithdrawalModel: [],
                        ChangesToBeModeled: originSelected.filter((ele) => ele != model).toString(),
                    },
                });
                break;
            case whatifProcess.AddOneOffWithdrawal:
                onChange({
                    Contribution: {
                        ...data?.Contribution,
                        OneOffWithdrawal: {
                            ...data?.Contribution?.OneOffWithdrawal,
                            Amount: { Amount: null, Currency: CurrencyCode.GBP },
                        },
                        ChangesToBeModeled: originSelected.filter((ele) => ele != model).toString(),
                    },
                });
                break;
            default:
                break;
        }
    };

    private formatChangesToBeModeled(orgin = "", add: string[]) {
        const orginArray = (orgin || "").split(",");
        const newArray = orginArray.concat(add).filter((ele) => ele !== "");
        return newArray.toString();
    }

    private prepopulateData = (model: whatifProcess) => {
        const { data, onChange, extraInfo } = this.props;
        const origin = data?.Contribution?.ChangesToBeModeled || "";
        const add = [model];
        switch (model) {
            case whatifProcess.editPaymentIn:
                add.push(whatifProcess.editInvestmentSeletion);
                if (!origin.split(",").includes(whatifProcess.editAdviserCharges)) {
                    add.push(whatifProcess.editAdviserCharges);
                }
                onChange({
                    Contribution: {
                        ...data?.Contribution,
                        ClientRegularPayment: extraInfo?.ClientRegularPayment
                            ? {
                                  ...extraInfo?.ClientRegularPayment,
                                  WasPaymentChanged: true,
                                  FirstCollectionDate: extraInfo?.ClientRegularPayment?.NextPaymentDate,
                              }
                            : null,
                        ThirdPartyRegularPayment: extraInfo?.ThirdPartyRegularPayment
                            ? {
                                  ...extraInfo?.ThirdPartyRegularPayment,
                                  WasPaymentChanged: true,
                                  FirstCollectionDate: extraInfo?.ThirdPartyRegularPayment?.NextPaymentDate,
                              }
                            : null,
                        InstrumentSelections: extraInfo?.InstrumentSelections,
                        OngoingAdviceCharge: extraInfo?.OngoingAdviceCharge,
                        ChangesToBeModeled: this.formatChangesToBeModeled(origin, add),
                    },
                });
                break;
            case whatifProcess.editAdviserCharges:
                onChange({
                    Contribution: {
                        ...data?.Contribution,
                        OngoingAdviceCharge: extraInfo?.OngoingAdviceCharge,
                        ChangesToBeModeled: this.formatChangesToBeModeled(origin, add),
                    },
                });
                break;
            case whatifProcess.AddAdditionalAdviserCharge:
                this.onDataChange(
                    onChange,
                    {
                        ChangesToBeModeled: this.formatChangesToBeModeled(origin, add),
                    },
                    data,
                    "Contribution"
                );
                break;
            case whatifProcess.AddEditRegularWithdrawals:
                onChange({
                    Contribution: {
                        ...data?.Contribution,
                        RegularWithdrawalModel: extraInfo?.RegularWithdraws,
                        ChangesToBeModeled: this.formatChangesToBeModeled(origin, add),
                    },
                });
                break;
            case whatifProcess.AddOneOffWithdrawal:
                this.onDataChange(
                    onChange,
                    {
                        ChangesToBeModeled: this.formatChangesToBeModeled(origin, add),
                    },
                    data,
                    "Contribution"
                );
                break;
            default:
                break;
        }
    };

    private getOptions = () => {
        const { data } = this.props;
        const selectedModel = (data?.Contribution?.ChangesToBeModeled || "").split(",");

        const options = [];

        whatIfModelArray.forEach((type) => {
            options.push({
                label: type,
                value: selectedModel.includes(type),
                disabled:
                    type == whatifProcess.editInvestmentSeletion ||
                    (type == whatifProcess.editAdviserCharges && selectedModel.includes(whatifProcess.editPaymentIn)),
                onChange: (v) => {
                    if (v) {
                        this.prepopulateData(type);
                    } else {
                        this.clearData(type);
                    }
                },
            });
        });

        return options;
    };

    public render(): JSX.Element {
        const options = this.getOptions();
        const account = ClientAccountStore.getClientAccountInfo()?.SubAccounts.find(
            (ele) => ele.HierarchyId == getQueryParameters()["subaccounthierarchyid"]
        );
        return (
            <>
                <h2>{`${account?.ProductDisplayName} ${account?.ClAccountId}`}</h2>
                {SectionHeader("Changes to be modelled")}
                <CheckboxGroup options={options} type={"panel"} wrapCss="control-size-430" />
            </>
        );
    }
}
